<template>
	<div class="tusd-wrap wrap-bg alipay">
		<div class="page-title">
			<i class="back-btn" @click="goBack('bankGroupManage')"></i>
			分组管理-添加分组
		</div>
		<div class="separator"></div>
		<div class="account-wrap">
			<div class="wrap-item">
				<span class="item-label">
					分组名称
				</span>
				<input type="text" v-model="bankGroup.title" placeholder="请输入分组名称" />
			</div>
			<div class="wrap-item">
				<span class="item-label">分组类型</span>
				<cube-select v-model="bankGroup.payType"   :options="bangGroupType"   >
				</cube-select>
			</div>
			
			<!-- <div class="wrap-item">
				<span class="item-label">每日限额：</span>
				<span class="unit">元</span>
				<input type="text" v-model="account.dayLimit"  placeholder="请输入每日限额" />
			</div>
			<div class="wrap-item">
				<span class="item-label">单笔限额：</span>
				<span class="unit">元</span>
				<input type="text" v-model="account.perLimit" placeholder="请输入单笔限额" />
			</div> -->
			<div class="wrap-item">
				<span class="item-label">开始服务时间：</span>
				<cube-select v-model="bankGroup.startServiceTime"  :options="startTimeOptions"  >
				</cube-select>
			</div>
			<div class="wrap-item">
				<span class="item-label">结束服务时间：</span>
				<cube-select v-model="bankGroup.endServiceTime"   :options="endTimeOptions"   >
				</cube-select>
			</div>
			<div class="wrap-item">
          <span class="item-label">是否启用：</span>
          <div class="radio-wrap">
            <cube-radio-group
              @input="changeStatus"
              v-model="bankGroup.isUse"
              :options="isUseOptions"
              :horizontal="true"
            />
          </div>
        </div>
			<div class="tusd-btn first-btn" @click="addBankGroup">确认添加</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'addBankGroup',
	data() {
		return {
			bankGroup: {
				title:"",
				id:0,
				startServiceTime:0,
				endServiceTime:23,
				payType: "",
				isUse: 1
			},
			params: {},
			bangGroupType: [
				{ value: 1, text: "银行卡" },		
			],
			startTimeOptions: [
				{ value: 0, text: "00:00:00 (北京时间)" },
				{ value: 1, text: "01:00:00 (北京时间)" },
				{ value: 2, text: "02:00:00 (北京时间)" },
				{ value: 3, text: "03:00:00 (北京时间)" },
				{ value: 4, text: "04:00:00 (北京时间)" },
				{ value: 5, text: "05:00:00 (北京时间)" },
				{ value: 6, text: "06:00:00 (北京时间)" },
				{ value: 7, text: "07:00:00 (北京时间)" },
				{ value: 8, text: "08:00:00 (北京时间)" },
				{ value: 9, text: "09:00:00 (北京时间)" },
				{ value: 10, text: "10:00:00 (北京时间)" },
				{ value: 11, text: "11:00:00 (北京时间)" },
				{ value: 12, text: "12:00:00 (北京时间)" },
				{ value: 13, text: "13:00:00 (北京时间)" },
				{ value: 14, text: "14:00:00 (北京时间)" },
				{ value: 15, text: "15:00:00 (北京时间)" },
				{ value: 16, text: "16:00:00 (北京时间)" },
				{ value: 17, text: "17:00:00 (北京时间)" },
				{ value: 18, text: "18:00:00 (北京时间)" },
				{ value: 19, text: "19:00:00 (北京时间)" },
				{ value: 20, text: "20:00:00 (北京时间)" },
				{ value: 21, text: "21:00:00 (北京时间)" },
				{ value: 22, text: "22:00:00 (北京时间)" },
				{ value: 23, text: "23:00:00 (北京时间)" }],
			endTimeOptions: [
				{ value: 0, text: "00:59:59 (北京时间)" },
				{ value: 1, text: "01:59:59 (北京时间)" },
				{ value: 2, text: "02:59:59 (北京时间)" },
				{ value: 3, text: "03:59:59 (北京时间)" },
				{ value: 4, text: "04:59:59 (北京时间)" },
				{ value: 5, text: "05:59:59 (北京时间)" },
				{ value: 6, text: "06:59:59 (北京时间)" },
				{ value: 7, text: "07:59:59 (北京时间)" },
				{ value: 8, text: "08:59:59 (北京时间)" },
				{ value: 9, text: "09:59:59 (北京时间)" },
				{ value: 10, text: "10:59:59 (北京时间)" },
				{ value: 11, text: "11:59:59 (北京时间)" },
				{ value: 12, text: "12:59:59 (北京时间)" },
				{ value: 13, text: "13:59:59 (北京时间)" },
				{ value: 14, text: "14:59:59 (北京时间)" },
				{ value: 15, text: "15:59:59 (北京时间)" },
				{ value: 16, text: "16:59:59 (北京时间)" },
				{ value: 17, text: "17:59:59 (北京时间)" },
				{ value: 18, text: "18:59:59 (北京时间)" },
				{ value: 19, text: "19:59:59 (北京时间)" },
				{ value: 20, text: "20:59:59 (北京时间)" },
				{ value: 21, text: "21:59:59 (北京时间)" },
				{ value: 22, text: "22:59:59 (北京时间)" },
				{ value: 23, text: "23:59:59 (北京时间)" }],
			isUseOptions: [
				{
					label: "是",
					value: 1
				},
				{
					label: "否",
					value: 0
				}
			]
		};
	},   
	methods: {
		goBack() {
			this.$router.push({ name: this.params.back });
		},
		changeStatus(v) {
			this.bankGroup.isUse = v;
		},
		addBankGroup(){
			let that=this;
			if(!that.bankGroup.title ){
				that.$message.popup("请输入分组名称",1000);
				return false
			}
			if(!that.bankGroup.payType ){
				that.$message.popup("请输入分组类型",1000);
				return false
			}
			that.$api.updateUserBankGroup(that.bankGroup).then((res)=>{
				that.$message.popup(res.msg,1000);
				setTimeout(() => {
					that.goBack();
				}, 1000);
			})
		},
       
	},
	created() {
		this.params = this.$store.state.routerStore.addBankGroup;
		if (!this.params.back) {
			this.params.back = 'bankGroupManage';
		}
		var userInfo = this.$store.state.userInfo;
		var bangGroupType = [];
		
		if (userInfo.PayTypeLimit.includes("1")) {
			bangGroupType.push({ value: 1, text: "银行卡" });
		}
		if (userInfo.PayTypeLimit.includes("2")) {
			bangGroupType.push({ value: 2, text: "支付宝" });
		}
		this.bangGroupType = bangGroupType;
	}
};
</script>
<style lang="less" scoped>

</style>
